import VSpeedDial from './VSpeedDial';

VSpeedDial.install = function install(Vue) {
  Vue.component(VSpeedDial.name, VSpeedDial);
};

export default VSpeedDial;


//////////////////
// WEBPACK FOOTER
// ./~/vuetify/es5/components/VSpeedDial/index.js
// module id = oB7h
// module chunks = 0